export default {
    search: 'Otsing',
    enter_the_city: 'Sisestage linn',
    to_download: 'Allalaaditav',
    make_an_appointment: 'REGISTREERU',
    only_with: '',
    calculate_route: 'LEIA TEEKOND',
    e_conference: 'E-konsultatsioonid'
}
